//@ts-check
import { useSearchParams } from 'react-router-dom';

import { PUBLISHER_TAB_MAP } from '../../../pages/publisher/utils/publisher-data';
import useCcPublisherApps from '../../ccextApi/selectors/useCcPublisherApps';
import useEcPublisherApps from './useEcPublisherApps';

/** @typedef {Parameters<useCcPublisherApps>[0] & Parameters<useEcPublisherApps>[0]} UsePublisherAppsQueryOptions */

/** @param {{type?: 'cc'|'ec'|'dc'} & UsePublisherAppsQueryOptions} [props] */
const usePublisherApps = ({ type = 'ec', ...options } = { type: 'ec' }) => {
  const [searchParams] = useSearchParams();
  const page = Number(searchParams.get('page') ?? '1');
  const pageIndex = page - 1;
  const tab = searchParams.get('tab');
  const isSolutionsTab = tab === PUBLISHER_TAB_MAP.SOLUTIONS.id;

  const solutionsQuery = useEcPublisherApps({
    appType: 'SLN',
    enabled: type === 'ec',
    pageIndex: isSolutionsTab ? pageIndex : 0,
    ...options,
  });
  const totalSolutions = solutionsQuery.data?.totalCount;

  const usePublisherApps = type === 'cc' ? useCcPublisherApps : useEcPublisherApps;
  const applicationsQuery = usePublisherApps({
    pageIndex: !totalSolutions || !isSolutionsTab ? pageIndex : 0,
    ...options,
  });

  const activeQuery = totalSolutions && isSolutionsTab ? solutionsQuery : applicationsQuery;
  const isLoading = (solutionsQuery.isFetching && solutionsQuery.isLoading) || applicationsQuery.isLoading;

  return { applicationsQuery, solutionsQuery, activeQuery, isLoading, page };
};

export default usePublisherApps;
